/** Find a column definition by AG Grid `field` (including nested group children). */
export function findColDefByField(defs, fieldKey) {
  if (!Array.isArray(defs) || !fieldKey) {
    return null;
  }
  for (const def of defs) {
    if (def.field === fieldKey) {
      return def;
    }
    if (def.children) {
      const nested = findColDefByField(def.children, fieldKey);
      if (nested) {
        return nested;
      }
    }
  }
  return null;
}

/** Column defs array, or grid-ready `{ api, columnApi }` to resolve defs from. */
export function resolveColumnDefsForFilter(source) {
  if (!source) {
    return null;
  }
  if (Array.isArray(source)) {
    return source;
  }
  const api = source.api;
  if (api && typeof api.getColumnDefs === 'function') {
    try {
      const fromApi = api.getColumnDefs();
      if (Array.isArray(fromApi)) {
        return fromApi;
      }
    } catch (e) {
      /* ignore */
    }
  }
  const columnApi = source.columnApi;
  if (columnApi && typeof columnApi.getAllGridColumns === 'function') {
    try {
      return columnApi.getAllGridColumns().map((c) => c.getColDef());
    } catch (e) {
      /* ignore */
    }
  }
  return null;
}

/** When a column has `convertToBoolean: true`, map set-filter values "Yes"/"No" to booleans for the server payload. */
export function applyConvertToBooleanSetFilters(model, columnDefs) {
  if (!model || !columnDefs) {
    return;
  }
  for (const key of Object.keys(model)) {
    const colDef = findColDefByField(columnDefs, key);
    if (!colDef?.convertToBoolean) {
      continue;
    }
    const fm = model[key];
    if (fm?.filterType === 'set' && Array.isArray(fm.values)) {
      fm.values = fm.values.map((v) => (v === 'Yes' ? true : v === 'No' ? false : v));
    }
  }
}

/** When a column defines `convertSetFilterValuesToApi`, map set-filter UI values before the server payload. */
export function applySetFilterValueTransforms(model, columnDefs) {
  if (!model || !columnDefs) {
    return;
  }
  for (const key of Object.keys(model)) {
    const colDef = findColDefByField(columnDefs, key);
    if (typeof colDef?.convertSetFilterValuesToApi !== 'function') {
      continue;
    }
    const fm = model[key];
    if (fm?.filterType === 'set' && Array.isArray(fm.values)) {
      fm.values = colDef.convertSetFilterValuesToApi(fm.values);
    }
  }
}
